import $store from '@/store'

window.getProfileObj = () => {
  const { me } = $store.state.auth
  const { malls } = $store.state.mall
  const { contracts } = $store.state.contract
  const isServiceAvailable = $store.getters['contract/isServiceAvailable']

  if (me) {
    const { userId, user_id } = $store.state.auth.info
    if (userId) {
      me.id = userId
    } else {
      me.id = user_id
    }
  }
  return {
    me,
    malls,
    contracts,
    isServiceAvailable,
  }
}
